<template>
  <div style="display: flex;flex-direction: column;">
    <el-card :body-style="titleCard" class="title">
      <div class="item" style="background: #fff">
        <div style="flex: 1">
          <div class="pro-content">
            <!-- <span class="proTitle">{{title.title}}</span>
            <span> <el-button @click="showTitle" >click</el-button></span> -->
            <div class="title-list">
              <span v-for="item in titleList" class="proTitle" :key="item.projectName" @click="titleClick(item)">{{
                (item.seq || '') + item.projectName }}
                <span class="el-icon-d-arrow-right" style="font-weight: 600" v-show="item.spe"></span>
              </span>
            </div>
            <div class="pro-des">
              <span style="font-weight: 600; margin-right: 5px">
                {{ title.type }}</span>
              <span v-if="!!title.des">·</span>
              <span>{{ title.des }} </span>
            </div>
          </div>
          <WorkflowBtn>
            <el-button size="mini" style="margin-left: 10px" @click="getBrowser">
              <i class="icon iconfont icon-shuzhuang xx-icon"></i>
              {{ $t("message.button.TreeView") }}</el-button>
            <el-button size="mini" style="margin-left: 10px" @click="openGanttChart">
              <i class="icon iconfont icon-shuzhuang xx-icon"></i>
              {{ $t("message.button.gantt") }}</el-button>
          </WorkflowBtn>
        </div>
        <div style="width: 15%">
          <div class="progress">
            <el-progress type="dashboard" :width="120" :percentage="percentage" :format="percetageLabel"></el-progress>
          </div>
        </div>
        <div style="width: 15%">
          <Light v-for="item in statusTypes" :statusType="item" :key="item.index"></Light>
        </div>
      </div>
    </el-card>

    <div class="nav">
      <Navbar @tabClick="tabClick" :navList="tabList"></Navbar>
    </div>

    <div class="route-content">
      <router-view @refreshTab="refreshTab" :key="getRouteKey"> </router-view>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Navbar from "./components/navbar.vue";
import "@/assets/css/icon-swift.css";
import Light from "./components/light.vue";
import WorkflowBtn from "./components/workflowBtn.vue";
import { projectTabList } from "@/utils/publicstate";
import { getTabIndex } from "@/utils/index.js";
import { mapGetters } from "vuex";
export default {
  name: "project",
  data() {
    return {
      titleCard: { padding: "0px" },
      colors: ["#13ce66", "#fcad2c", "#f56c6c"],
      // statusTypes: [],
      // type:0,
      // typeList:['未开始','进行中','已完成','拒绝','逾期'],
      tabList: [],
      title: {
        name: "",
        des: " ",
        type: ' ',
      },
      userList: [],
      statusList: [],
      tableInfo: [],

      titleList: [],

      deletePriv: false,
      reloadRouter: false,
      isRouterAlive: true,
      disableDel: false,
      directorDisable: false,
      rootId: "",
      objectId: {},
    };
  },
  components: {
    Navbar,
    Light,
    WorkflowBtn,
  },

  methods: {
    titleClick(item) {
      item.title = item.projectName;
      if (item.spe) {
        this.getLink(item);
      }
    },
    showTitle() {
      const n = this.titleList.map((i) => i.projectName).join("/");
      this.$set(this.title, "title", n);
    },


    transData(arr) {
      let newArr = [];
      arr.map((i) => {
        let n = {
          id: i.objId,
          projectNumber: i.projectNumber,
        };
        newArr.push(n);
        if (i.children) {
          n.children = this.transData(i.children);
        }
      });
      return newArr;
    },
    getBrowser() {
      this.$emit("getBrowserPage", this.rootId);
    },
    // 打开甘特图
    openGanttChart() {
      var obj_get = {
        ...this.objectId,
        tableId: 54,
      };
      let tableData = {};
      axios
        .get(`/ppm/project/getScheduleTableList${this.params(obj_get)}`)
        .then((res) => {
          if (res.data.code == 200) {
            tableData = res.data.object.table;
            const routeData = this.$router.resolve({
              path: "/Gantt",
            });
            let json = JSON.stringify(tableData);
            sessionStorage.setItem("data", json);
            window.open(routeData.href, "_blank");
          }
        });
    },
    openXX() {
      const routeData = this.$router.resolve({
        path: "/criticalPath",
      });
      window.open(routeData.href, "_blank");
    },

    checkDelPriv(e) {
      if (e) {
        const arr = JSON.parse(sessionStorage.getItem("userContext")).privs;
        const privsArr = arr.map((i) => {
          return i.type;
        });
        if (privsArr.indexOf(25) != -1) {
          this.deletePriv = true;
        }
      }
    },


    // getTab(e) {
    //   this.$router.push(this.tabList[e].path);
    // },
    tabClick(res) {
      this.$router.push({
        path: res.path,
        query: { ...this.objectId },
      });
    },
    deletePage(e) {
      this.$emit("deletePage");
      // this.$parent.cc();
    },

    // getItemData() {
    //   var obj_get = {
    //     ... this.objectId,
    //      tableId: 1,
    //   };
    //   axios.get(`/ppm/project/loadTable${this.params(obj_get)}`).then((res) => {
    //     if (res.data.code == 200) {

    //       const { rootId, table, userList } = res.data.object

    //       this.$store.commit("setProjectCreatedBy", table.createdBy);
    //       this.rootId = rootId;

    //       this.$store.commit('setProjectRootId', this.rootId)
    //       const list = userList.map(i => (
    //         {
    //           value: i.id + '',
    //           label: i.loginId + "(" + (i.userName || "") + ")",
    //         }
    //       ))
    //       this.$store.commit('setUserList', list)

    //       this.tableInfo = res.data.object;

    //       const val = table.rows[0].cells;
    //       let arr = this.getNewData(table.columnInfo);
    //       arr.map((i, e) => {
    //         i.val = val[e];
    //       });

    //       this.title = {
    //         name: arr.find((i) => i.id == 1051012)?.val.val || '',
    //         type: arr.find((i) => i.id == 1051009)?.val.val || '',
    //         des: arr.find((i) => i.id == 1051013)?.val.val || '',
    //         status: arr.find((i) => i.id == 1051019)?.val.id || '',
    //         statusLabel: arr.find((i) => i.id == 1051019)?.val.val || '',
    //       };

    //       this.title.title = this.title.name;

    //       this.titleList = JSON.parse(table.rows[0].projectObjArray).map((i, e) => ({ ...i, spe: !e ? '' : '/ ', seq: ' ' })).reverse()

    //       this.getWBS(this.rootId);

    //       // const tabs = this.$store.getters.getShowingTabInHome; //已存在的list数据
    //       // let currentTab = tabs.find(
    //       //   (i) => i.objId == this.objectId.id
    //       // );

    //       // if (
    //       //   !!currentTab &&
    //       //   this.objectId.id != rootId
    //       // ) {
    //       //   currentTab.rootId = setCheckrootId;
    //       //   this.$store.commit("replaceShowingTabsInHome", tabs);
    //       // }

    //       // let activeName = this.$store.getters.getActivedTabInHome;
    //       //添加最近访问
    //       this.addRecentVistInCommon({
    //         baseClassId: this.Constants.projectBaseClassId,
    //         number: this.title.name,
    //         ... this.objectId,
    //         //id: this.$store.state.objId_,
    //       });

    //       this.updateFavoriteInCommon({
    //         baseClassId: this.Constants.projectBaseClassId,
    //         number: this.title.name,
    //         ... this.objectId,
    //         //id: this.$store.state.objId_,
    //       });
    //     }
    //   }).catch((err) => {
    //     // this.objectDelConfirm('deletePro')
    //   })
    //   // .catch(this.objectDelConfirm('deletePro'))
    // },

    getData(data) {
      const { columnInfo, rows, createdBy } = data;
      const [info] = rows,
        { projectObjArray, cells } = info;
      this.titleList = JSON.parse(projectObjArray).map((i, e) => ({ ...i, spe: !e ? '' : '/ ', seq: ' ' })).reverse();

      const { ids } = columnInfo;
      // const index = ids.indexOf(1051012);
      // const number = cells[index].val;

      const [number, type, des] = [1051012, 1051009, 1051013].map(i => {
        const index = ids.indexOf(i);
        return cells[index].val
      })
      this.title = { ...this.title, type, des }

      this.addRecentVistInCommon({
        baseClassId: this.Constants.projectBaseClassId,
        number,
        ... this.objectId,
        //id: this.$store.state.objId_,
      });

      //       this.title = {
      //         name: arr.find((i) => i.id == 1051012)?.val.val || '',
      //         type: arr.find((i) => i.id == 1051009)?.val.val || '',
      //         des: arr.find((i) => i.id == 1051013)?.val.val || '',
      //         status: arr.find((i) => i.id == 1051019)?.val.id || '',
      //         statusLabel: arr.find((i) => i.id == 1051019)?.val.val || '',
      //       };

      // const col = this.columnInfoFix(columnInfo);
      // const page = buildPageData({ columnInfo: col, rows });

      // const titleConfig = [
      //   { id: 1051010, attri: "val", prop: "manager", defaultVal: [] },
      //   { id: 1051011, attri: "val", prop: "header", defaultVal: [] },
      //   { id: 1051020, attri: "val", prop: "observer", defaultVal: [] },
      //   // { id: 1051019, attri: "val", prop: "creater", defaultVal: "" },
      // ];
      // let info = buildProjectInfo(titleConfig, page);
      // const userList = [...info.manager, ...info.header, createdBy].map((i) =>
      //   Number(i)
      // );
      // this.editEnable =
      //   (userList.includes(userId) && pagePriv.includes(3)) || superMan;
    },

    getProjectXX() {
      const { subClassId, id } = this.objectId;

      const arr = [
        axios.get(`/pmdm/admin/getTab/${subClassId}`),
        // axios.get(`ppm/project/getProjectStatusById?projectId=${id}`),
      ];
      Promise.all(arr).then((res) => {
        const [{ tabs },] = res.map((i) => i.data.object);

        // this.setLightInfo(Info);
        this.setTablist(tabs);
      });
    },
    setTablist(tabs) {
      this.tabList = tabs.map(i => {
        i.path = projectTabList.find((j) => j.id == i.id)?.path || "";
        return i;
      });
      const tabIndex = getTabIndex({ ...this.objectId })?.index || 0;
      this.tabClick(
        projectTabList.find((j) => j.id == this.tabList[tabIndex].id)
      );
      this.refreshTab();
    },
    async refreshTab() {
      try {
        const tabIds = this.tabList.map(({ id }) => id);
        const usedTabs = await this.$getTabsIsUsedResult(tabIds);
        this.tabList.forEach(tab => {
          const isUsed = usedTabs.includes(tab.id);
          this.$set(tab, 'isResult', isUsed);
        });
        console.log(this.tabList);

      } catch (error) {
        console.error('Tab refresh failed:', error);
      }
    },

    percetageLabel() {
      // return `  ${percentage}% ${this.typeList[this.type - 1]} `;
      const { currectStatus, specialProjectVo } = this.projectStatus, { specialState } = specialProjectVo, { name } = currectStatus;
      const arr = [name, '暂停', '关闭']
      const label = arr[specialState];
      return this.percentage + "%" + "\n\n" + label;
    },
  },
  mounted() { },
  computed: {

    ...mapGetters({
      pageOne: 'project/getPageOne',
      projectStatus: 'projectWorkflow/getProjectInfo',
      projectLight: 'projectWorkflow/getProjectLight'
    }),
    percentage() {
      const { percentComplete } = this.projectLight;
      return percentComplete;
    },

    statusTypes() {
      const { timeHealth, costHealth, statusType } = this.projectLight;
      const
        resourceStatusColorId = !timeHealth ? 0 : 2,
        costStatusColorId = !costHealth ? 0 : 2,
        tempStatusType = 5 - statusType,
        scheduleStatusColorId = tempStatusType === 0 ? 2 : (tempStatusType > 0 ? 0 : 1);
      let list = [scheduleStatusColorId, costStatusColorId, resourceStatusColorId];
      const overallStatusColorId = list.includes(2) ? 2 : (!list.includes(1) ? 1 : 0);
      list = [overallStatusColorId, ...list];
      const arr = [
        { name: this.$t("message.title.OverallStatus"), type: 0 },
        { name: this.$t("message.title.ScheduleStatus"), type: 0 },
        { name: this.$t("message.title.CostStatus"), type: 0 },
        { name: this.$t("message.title.ResourceStatus"), type: 0 },
      ].map((i, e) => {
        i.type = list[e]
        return i;
      });
      return arr;
    },
    getRouteKey() {
      const { currectStatus, projectStatusList } = this.projectStatus;
      const { id } = currectStatus
      return id
    }

  },
  watch: {
    pageOne(val) {
      console.log("load pageOne in watch", val);
      this.getData(val);
    },

  },
  created() {
    const { id, classId, subClassId } = this.$route.query;
    const obj = { id, classId, subClassId };
    this.objectId = obj;
    this.$store.commit("setObjectId", obj);
    // this.getItemData();
    // this.getTabData();
    // this.getProjectStatusById();
    this.getProjectXX();
    this.$store.dispatch("project/getData", obj);
    this.$store.dispatch("projectWorkflow/getWorkFlowStatus", obj);
    this.$store.dispatch("projectWorkflow/queryProjectChange", obj);
  },
};
</script>
<style>
.progress .el-progress--dashboard .el-progress__text {
  white-space: pre-wrap;
}
</style>

<style scoped lang="scss">
.route-content {
  padding: 10px 15px;
  box-sizing: border-box;
  flex: 1;
  min-height: 0px;
  // height: calc(100vh - 320px);
  // overflow-y: scroll;
}

.pro-content {
  margin-left: 20px;
  width: 100%;
  word-wrap: break-word;
  word-break: normal;

  .title-list {
    padding: 5px 0;
    width: 100%;
    word-wrap: break-word;
    word-break: normal;
  }
}

.proTitle {
  font-size: 20px;
  font-weight: bold;
  color: #4b92ff;
  /* width: 500px; */
  overflow: hidden;
  white-space: nowrap;
  /*规定文本不进行换行*/
  text-overflow: ellipsis;
  cursor: pointer;
}

.xx-icon {
  font-size: 12px;
  /* transform: rotate(90deg) rotateY(180deg); */
}

.pro-des {
  overflow: hidden;
  margin: 5px 0;
  margin-bottom: 10px;
  white-space: nowrap;
  /*规定文本不进行换行*/
  text-overflow: ellipsis;
}

.title {
  min-height: 130px;
  z-index: 99;
}

.item {
  min-height: 136px;
  display: flex;
  align-items: center;
}

.item-title {
  /* width: 68%; */
  word-wrap: break-word;
  word-break: normal;
}

.progress {
  margin: 10px 0 0 5px;
  position: relative;
}

.progress .el-progress-circle {
  height: 86px;
  width: 86px;
}

/* .nav {
  padding-left: 15px;
  border-bottom: 2px solid #fff;
   box-sizing: content-box;
  z-index: -1;
} */
</style>
